__turbopack_context__.v({
  "categoriesSubtitle": "PriceRatingModal-module__vP29rW__categoriesSubtitle",
  "categoryContainer": "PriceRatingModal-module__vP29rW__categoryContainer",
  "categoryText": "PriceRatingModal-module__vP29rW__categoryText",
  "content": "PriceRatingModal-module__vP29rW__content",
  "modalContent": "PriceRatingModal-module__vP29rW__modalContent",
  "modalIntro": "PriceRatingModal-module__vP29rW__modalIntro",
  "subtitle": "PriceRatingModal-module__vP29rW__subtitle",
});
